export default "__VITE_ASSET__u2mK8h30__"